<template>
  <li class="px-3 py-2 text-dark">
    <slot></slot>
  </li>
</template>

<script>
export default {
  name: "DropdownOption",
};
</script>
